module.exports = __webpack_public_path__ + "img/user.8218556c.png";